import MetaPresenter from 'components/meta/containers/MetaPresenter';
import MetaH1 from 'components/meta/containers/MetaH1';
import Breadcrumbs from 'components/breadcrumbs/containers/Breadcrumbs';
import * as React from 'react';
import MenuBalance from 'moduleBase/modules/menu-balance/containers/MenuBalance';
import { Profile } from 'moduleBase/components/header/profile/Profile';
import { When } from 'react-if';
import Notifier from 'modules/chat/modules/notifier/containers/Notifier';
import app from 'srcJs/App';
import { ConfirmEmailNotifier } from 'moduleBase/components/header/confirm-email-notifier/ConfirmEmailNotifier';
import CartNotifier from 'moduleCartNotifier/containers/CartNotifier';
import { AlertInformationList } from 'moduleBase/components/alert-information/AlertInformationList';

var Header = function Header(_ref) {
  var userMenu = _ref.userMenu,
      alerts = _ref.alerts;
  var user = app.getUser();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MetaPresenter, null), /*#__PURE__*/React.createElement("div", {
    className: "page-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container container-lg-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center flex-nowrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col min-w-0"
  }, /*#__PURE__*/React.createElement(MetaH1, null), /*#__PURE__*/React.createElement(Breadcrumbs, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-auto d-none d-xl-block"
  }, /*#__PURE__*/React.createElement(Notifier, null)), /*#__PURE__*/React.createElement(When, {
    condition: user.isCustomer()
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto d-none d-xl-block"
  }, /*#__PURE__*/React.createElement(CartNotifier, null))), /*#__PURE__*/React.createElement(MenuBalance, null), /*#__PURE__*/React.createElement(Profile, {
    userMenu: userMenu
  })))), /*#__PURE__*/React.createElement("div", {
    className: "bg-white d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container container-lg-fluid"
  }, /*#__PURE__*/React.createElement(ConfirmEmailNotifier, null), /*#__PURE__*/React.createElement(AlertInformationList, {
    alerts: alerts
  }))));
};

export default Header;